import { createIconTextBannerComponent } from '@vfde-brix/ws10/icon-text-banner';
import { HtmlId } from '../enum';
import { mountComponent } from '../util/mount';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';

/**
 * Create Brix IconTextBanner component.
 * @param {string} id - ID of the banner element
 */
export const mountIconTextBanner = (id: HtmlId) =>
    mountComponent(id, createIconTextBannerComponent, NO_PATTERN_BUSINESS_LOGIC);
